import script from "./RequestTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestTable.vue?vue&type=script&setup=true&lang=js"

import "./RequestTable.vue?vue&type=style&index=0&id=1f232f0f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f232f0f"]])

export default __exports__